import { Box, Button, Chip, Divider, IconButton, Stack, Typography } from "@mui/material";
import RenderInputField from "components/Reports/ReusableComponents/RenderInputField/RenderInputField";
import { ArrowBackIosNewRounded, ClearRounded, FilterAltRounded } from "@mui/icons-material";
import { grey } from "@mui/material/colors";
import { getColumnValue } from "components/Reports/data";

export const drawerWidth = 240;

const PersistantDrawer = ({
	drawerOpen,
	setDrawerOpen,
	filter,
	setFilter,
	columns,
	children,
	anchor = "right",
	height,
	handleApplyClick,
	displayApplyBtn = false,
	sx = {},
}) => {
	const handleFilterDrawerClose = () => setDrawerOpen(false);

	// Drawer style (absolute inside parent)
	const drawerStyle = {
		position: "absolute",
		top: 0,
		[anchor]: 0,
		width: `${drawerWidth}px`,
		height: height,
		backgroundColor: "background.paper",
		boxShadow: 3,
		zIndex: 2,
		transition: "transform 0.3s ease-in-out",
		transform: drawerOpen ? "translateX(0)" : `translateX(${anchor === "left" ? -drawerWidth - 20 : drawerWidth}px)`,
		overflowY: "auto",
	};

	return (
		<Box sx={{ position: "relative", display: "flex", columnGap: 1 }}>
			<Box sx={drawerStyle}>
				<Stack p={1} sx={{ spacing: 1, ...sx }}>
					<Box display="flex" alignItems="center" columnGap={1} width="100%" justifyContent="space-between">
						<Typography variant="h6">Filters</Typography>
						<IconButton size="small" onClick={handleFilterDrawerClose}>
							<ArrowBackIosNewRounded sx={{ transform: "scale(0.8)" }} />
						</IconButton>
					</Box>
					<Divider />
					{children ||
						columns?.map((col) => (
							<RenderInputField
								key={col.key}
								column={col}
								data={filter}
								setData={setFilter}
								selectOptObjName={"select_options"}
								width="100%"
								longWidth="100%"
								disabled={false}
							/>
						))}

					{displayApplyBtn && (
						// flotaing apply button at bottom
						<Box
							sx={{
								position: "sticky",
								bottom: 0,
								left: 0,
								background: "white",
								pt: 1,
								pb: 1,
							}}>
							<Button
								variant="contained"
								color="primary"
								fullWidth
								onClick={() => {
									handleApplyClick();
								}}>
								Apply
							</Button>
						</Box>
					)}
				</Stack>
			</Box>
		</Box>
	);
};

export default PersistantDrawer;
